import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";
import { pickLang } from "@/data/stoicosCards";
import { AL_LABELS, ABOUT_EDITION } from "@/data/ancientLibrary";

export const GREEK_FONT = { fontFamily: '"EB Garamond", Georgia, "Times New Roman", "Palatino Linotype", serif', fontFeatureSettings: '"locl" 0' };

export const useAlLabels = () => {
  const { lang } = useT();
  return { lang, labels: AL_LABELS[lang] || AL_LABELS.en };
};

export const AboutEditionNote = () => {
  const { lang, labels } = useAlLabels();
  return (
    <section className="mt-16 pt-8 border-t border-white/10" data-testid="al-about-edition">
      <h2 className="text-[11px] tracking-[0.3em] uppercase text-gold mb-4">{labels.aboutEdition}</h2>
      <p className="text-fog/80 font-reading text-sm md:text-base leading-[1.8] italic">{pickLang(ABOUT_EDITION, lang)}</p>
    </section>
  );
};

export const AlBreadcrumb = ({ items }) => (
  <nav className="mb-12 text-[11px] tracking-[0.2em] uppercase text-fog/70" data-testid="al-breadcrumb">
    {items.map((it, i) => (
      <span key={i}>
        {i > 0 && <span className="mx-2 text-fog/40">/</span>}
        {it.to ? <Link to={it.to} className="hover:text-gold transition-colors">{it.label}</Link> : <span className="text-gold/90">{it.label}</span>}
      </span>
    ))}
  </nav>
);
